export default function socketHost() {
  const host = window.location.host;
  let hostname = window.location.hostname;
  let _lang = 'en';

  if(host.indexOf('kqbd') != -1){
    return 'wss://kqbd.upgoal.com/ws/';
  }

  if(hostname.indexOf('en') > -1){
    _lang = 'en';
  }
  if(hostname.indexOf('kr') > -1){
    _lang = 'kr';
  }
  if(hostname.indexOf('th') > -1){
    _lang = 'th';
  }
  if(hostname.indexOf('vn') > -1){
    _lang = 'vn';
  }

  if(host.indexOf('dev') != -1 || host.indexOf('localhost') != -1 || host.indexOf('127.0.0.1') != -1){
    return 'wss://'+ _lang +'.dev.upgoal.com/ws/';
  }
  if(host.indexOf('test') != -1){
    return 'wss://'+ _lang +'.test.upgoal.com/ws/';
  }
  if(host.indexOf('staging') != -1){
    return 'wss://'+ _lang +'.staging.upgoal.com/ws/';
  }
  return 'wss://'+ _lang +'.upgoal.com/ws/';
}


// WEBPACK FOOTER //
// ./src/utils/socketHost.js